import React from 'react';

const defaultScrollOptions: ScrollIntoViewOptions = {
  behavior: 'smooth',
  block: 'start',
};

/**
 * Use this as a "div" replacement that can scroll itself into view when `scroll == true`.
 * Beware of rendering multiple of these with a truthy scroll value as they'll conflict with each other.
 */
export function ScrollIntoViewDiv(
  props: {
    scroll: boolean;
    scrollOptions?: ScrollIntoViewOptions;
    scrollContainerRef: React.RefObject<HTMLDivElement>;
  } & JSX.IntrinsicElements['div']
) {
  const {
    scroll,
    scrollOptions = defaultScrollOptions,
    scrollContainerRef,
    ...divProps
  } = props;
  const divRef = React.useRef<HTMLDivElement>(null);

  const performScrollIfNeeded = React.useCallback(() => {
    if (scroll && divRef.current && scrollContainerRef.current) {
      const containerRect = scrollContainerRef.current.getBoundingClientRect();
      const elementRect = divRef.current.getBoundingClientRect();

      scrollContainerRef.current.scrollTo({
        top:
          elementRect.top -
          containerRect.top +
          scrollContainerRef.current.scrollTop,
        behavior: scrollOptions.behavior,
      });
    }
  }, [scroll, scrollOptions, scrollContainerRef]);

  React.useEffect(() => {
    performScrollIfNeeded();
  }, [performScrollIfNeeded]);

  return <div {...divProps} ref={divRef} />;
}
